import { z } from "zod";

export const importGroupVisitorSchema = z.object({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string().email().optional(),
  zipCode: z.string().optional(),
});

export const importGroupFromCsvSchema = z.object({
  name: z.string().min(1, "Le nom du groupe ne peut pas être vide"),
  visitors: z
    .array(importGroupVisitorSchema)
    .min(1, "Au moins un visiteur doit être ajouté"),
});

export type ImportGroupVisitorForm = z.infer<typeof importGroupVisitorSchema>;
export type ImportGroupFromCsvForm = z.infer<typeof importGroupFromCsvSchema>;

export const importGroupFromCsvDefaultValues: ImportGroupFromCsvForm = {
  name: "",
  visitors: [],
};
